export default class extends Controller {
  static targets = ['fieldsTemplate', 'formSection', 'removeLinkContainer', 'destroyField'];

  connect() {
    this.hideOrShowX();
    if (this.atLeastOne && this.numberOfElements === 0) {
      this.addFieldSet();
    }
    this.destroyFieldTargets
      .filter(d => ['true', '1', true].indexOf(d.value) > -1)
      .forEach(d => this.closestSection(d).style.display = 'none');
  }

  addFieldSet(event) {
    event && event.preventDefault();
    const newFields = this.newElement;
    this.formSection.appendChild(newFields);
    setTimeout(() => {
      App.Form.initSelect2Complex(newFields);
      App.DynamicSelect.init(newFields)
    }, 100);
    this.hideOrShowX();
  }

  newFromKeyPress(event) {
    if (event && (event.keyCode == 13 || event.keyCode == 9)) {
      if (event.target.value) {
        this.addFieldSet(event);
        const items = [...document.querySelectorAll(this.fieldsQuerySelector)];
        items[items.length - 1].querySelector('input').focus();
      } else {
        this.hideFieldSet(event);
      }
    }
  }

  hideFieldSet(event) {
    event && event.preventDefault();
    const closestSection = this.closestSection(event.target);
    this.destroySelector && (closestSection.querySelector(this.destroySelector).value = '1');
    closestSection.style.display = 'none';
    this.hideOrShowX();
  }

  removeFieldSet(event) {
    event.preventDefault();
    event.target.closest(this.fieldsQuerySelector).remove();
    this.hideOrShowX();
  }

  //
  // INTERNAL USE
  //

  closestSection(el) {
    return el.closest(this.fieldsQuerySelector);
  }

  replaceID({ id, template }) {
    const time = new Date().getTime();
    const regex = new RegExp(id, 'g');
    return template.replace(regex, time);
  }

  hideOrShowX() {
    this.atLeastOne && this.removeLinkContainerTargets.forEach(x => x.style.display = this.numberOfElements == 1 ? 'none' : 'block');
  }

  //
  // GETTERS
  //

  get atLeastOne() {
    return this.data.has('at-least-one');
  }

  get newElement() {
    return App.Helpers.selectHTMLFromString(this.fieldsTemplate)[0];
  }

  get fieldsTemplate() {
    const id = this.fieldsTemplateTarget.dataset.id;
    const template = this.fieldsTemplateTarget.innerHTML;
    return id ? this.replaceID({ id, template }) : template;
  }

  get formSection() {
    return this.formSectionTarget;
  }

  get fieldsClassName() {
    return this.data.get('section-class');
  }

  get fieldsQuerySelector() {
    return this.data.get('fields-query-selector') || `.${this.fieldsClassName.replace(/\s+/g, '.')}`;
  }

  get destroySelector() {
    return this.data.has('destroy-selector') ? this.data.get('destroy-selector') : null;
  }

  get numberOfElements() {
    return document.querySelectorAll(this.fieldsQuerySelector).length;
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/shared/nested-fields-controller.js